import {Algorithm} from "./Algorithm";
import {UserInputOptionSelector} from "./UserInputOptionSelector";

export class Shoto extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      seasons: {
        "Base": "none",
        "Summer": "sunny",
        "Winter": "snowing",
      }
    };
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const [season, mode] = title.split("-").map(s => s.trim());
      return {key, season, mode, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.modeSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="mode"]`));
    this.modeSelector.on("userInputValueChanged", (value) => this.onUserInput(value));

    this.seasonSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="season"]`));
    this.seasonSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(this.modeSelector.getRealValue(), this.seasonSelector.getRealValue());

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update charts
    Object.entries(this.charts).forEach(([name, chart]) => {
      chart.loadDataset(targetCombination.index);
    });

    this.decisionLogs.update(this.currentKPIKey, this.buildingSelector.currentBuilding);

    this.sendWeatherOverride();
  }

  findUserCombination(mode, season) {
    // Let's return the entry where the value fits the correct values
    // Returns the first element if there is no match (which should not happen if data is set correctly)
    return this.rangesMap.find(entry => entry.mode === mode && entry.season === season) ?? this.rangesMap[0];
  }

  sendWeatherOverride() {
    if (!this.isActive) return;

    const season = this.seasonSelector.getRealValue();

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.seasons[season] ?? "none"}`);
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  resetUserInputs() {
    this.modeSelector.reset();
    this.seasonSelector.reset();
  }

}
